var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,3a3.31,3.31,0,0,0-4.62,0L3.36,16a1,1,0,0,0-.28.49L2,20.59a1.06,1.06,0,0,0,.28,1,1,1,0,0,0,.74.31,1.07,1.07,0,0,0,.25,0l4.19-1A1,1,0,0,0,8,20.56L21.07,7.61A3.19,3.19,0,0,0,22,5.32,3.24,3.24,0,0,0,21,3ZM6,19,4.5,19.4l.37-1.46ZM19.89,5.33a1.05,1.05,0,0,1-.34.81L7.78,17.79,6.1,16.21,17.9,4.54a1.19,1.19,0,0,1,1.66,0A1.11,1.11,0,0,1,19.89,5.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ba0efbfe5ca0c21b41bce18b8e16e057.svg";
export { ForwardRef as ReactComponent };